/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Link } from "@quintype/components";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BLOCKS, GIFTBLOCKS, TEXT } from "../constants";
import { SubscriptionHelper } from "../subscription-helpers";
// import assetify from "@quintype/framework/assetify";
// import merch from "../../../../../assets/images/nl-images/merch.png";
// import gift from "../../../../../assets/images/nl-images/nl-sena-page.png";
// import logo from "../../../../../assets/images/logo-nl.png";
import "./subscription-blocks.m.css";

const englishIndianPlanIds = [338, 1369, 340, 1378, 343];
const englishOverseasPlanIds = [1378, 343];
const hindiPlanIds = [1367, 338, 1369, 340, 4060, 4061];

export const SubscriptionBlocks = props => {
  const userCountryInfo = useSelector(state =>
    get(state, ["fetchUserCountry"], {
      country_code: "",
      country_code_alias: "",
      country_name: "",
      user_timezone: ""
    })
  );

  const userCountry = {
    country_code: userCountryInfo.country_code,
    country_name: userCountryInfo.country_name,
    country_code_alias: userCountryInfo.country_code_alias,
    user_timezone: userCountryInfo.user_timezone
  };

  const member = useSelector(state => get(state, ["member"], null));
  const [selectedBlocks, setSelectedBlocks] = useState([]);

  const [isHindi, setIsHindi] = useState(false);
  const [customHelperGCText, setCustomHelperGCText] = useState(null);

  useEffect(() => {
    setIsHindi(!!(global.location && global.location.host.includes("hindi")));

    if (
      userCountry.country_code === "IN" ||
      userCountry.country_code_alias === "IN"
    ) {
      const isHindiWeb =
        !!global.location && global.location.host.includes("hindi");
      //const isHindiWeb = true;

      if (isHindiWeb) {
        //console.log(BLOCKS);
        setSelectedBlocks(
          BLOCKS.filter(
            block =>
              block.planId !== 2033 && hindiPlanIds.includes(block.planId)
          )
        );
      } else {
        setSelectedBlocks(
          BLOCKS.filter(
            block =>
              block.planId !== 2033 &&
              englishIndianPlanIds.includes(block.planId)
          )
        );
      }
    } else {
      setSelectedBlocks(
        BLOCKS.filter(
          block =>
            block.planId !== 2033 &&
            englishOverseasPlanIds.includes(block.planId)
        )
      );
    }
  }, []);

  useEffect(() => {
    if (
      !userCountry.country_code === "IN" ||
      !userCountry.country_code_alias === "IN"
    ) {
      setCustomHelperGCText("You save ₹300/month");
    }
  }, [isHindi, selectedBlocks]);

  return (
    <div styleName="wrapper" className="full-width">
      <div styleName={props.gift ? "top-gift-wrapper" : "top-wrapper"}>
        {/* <MobileLogo /> */}
        {/* {props.gift && <img src={assetify(gift)} styleName="left-img" />}
        {props.gift && <img src={assetify(gift)} styleName="right-img" />}
        {!props.gift && <img src={assetify(merch)} styleName="left-img" />}
        {!props.gift && <img src={assetify(merch)} styleName="right-img" />} */}
        <h2 styleName="title">
          {!props.gift ? TEXT.subscriptionTitle : TEXT.giftTitle}
        </h2>
        <div styleName="red-line"></div>
        <p styleName="helper-text">
          {!props.gift ? TEXT.subscriptionDescription : TEXT.giftDescription}
        </p>
      </div>
      {!props.gift ? (
        <div
          styleName={`block-wrapper ${
            isHindi ? "two-col-grid" : "three-col-grid"
          }`}
        >
          {selectedBlocks.map((block, index) => {
            const toShowGC = block.groupId === 113 || block.groupId === 760;

            return (
              <Block
                data={block}
                key={index}
                value={index}
                member={member}
                URL={props.URL}
                isHindi={isHindi}
                intent="self_subscription"
                customHelperDisruptorText={null}
                customHelperGCText={toShowGC ? customHelperGCText : null}
              />
            );
          })}
        </div>
      ) : (
        <GiftBlocks member={member} />
      )}
      <SubscriptionHelper {...props} gift={props.gift} />
      <br />
    </div>
  );
};

const Block = ({
  data,
  value,
  gift,
  member,
  intent = "",
  isHindi = false,
  customHelperDisruptorText,
  customHelperGCText
}) => {
  const isRecurring = useSelector(state =>
    get(state, ["fetchSubscription", "isRecurring"], null)
  );
  const { fetchSubscription } = useSelector(state => state);

  const handleBtnClick = () => {
    const obj = {
      event: "subscription_addToCart",
      subscription_category: "self_subscription",
      subscription_plan: `${data.groupName} - ${data.planName}`,
      price: data.price,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    window.dataLayer.push(obj);

    isRecurring &&
      window.alert(
        "Oops!You already have a recurring subscription. Try sena, student or gift subscription."
      );
  };

  const oldRedirectURL = new URL(
    `https://${isHindi ? "hindi" : "www"}.newslaundry.com/subscription/checkout`
  );
  const searchParams = new URLSearchParams(oldRedirectURL.search);
  searchParams.append("intent", intent);
  searchParams.append("plan", data.planId);

  const redirectURL = new URL(
    `${oldRedirectURL.origin}${
      oldRedirectURL.pathname
    }?${searchParams.toString()}`
  );

  return (
    <div
      styleName={
        data.planId === 340 ||
        data.planId === 1369 ||
        customHelperGCText ||
        customHelperDisruptorText
          ? "block best-value"
          : "block"
      }
    >
      {data.planId === 340 || data.planId === 1369 ? (
        <small>BEST VALUE</small>
      ) : null}
      {customHelperGCText && <small>{customHelperGCText}</small>}
      {customHelperDisruptorText &&
        (data.planId === 1367 || data.planId === 338) && (
          <small>{customHelperDisruptorText}</small>
        )}
      <h3 styleName="block-title">{data.groupName.toUpperCase()}</h3>
      <div styleName="price-duration-wrapper">
        <div styleName="price-wrapper">
          {data.originalPrice && (
            <span>
              <strike>{data.originalPrice}</strike>
            </span>
          )}
          <h2 styleName="price">&#8377;{data.price}</h2>
        </div>
        <div styleName="duration">
          <p>{data.planName}</p>
        </div>
      </div>
      {data.originalPrice ? (
        <div styleName="discount-wrapper">
          <p>&#8377; {+data.originalPrice - +data.price} off</p>
        </div>
      ) : (
        <div></div>
      )}
      {!gift && (
        <Link
          href={
            !member
              ? `https://auth.newslaundry.com/user-login?callback-url=https://${
                  isHindi ? "hindi" : "www"
                }.newslaundry.com&redirect-url=${redirectURL.href}`
              : !isRecurring
              ? `/subscription/checkout?intent=${intent}&plan=${data.planId}`
              : ""
          }
        >
          <button onClick={handleBtnClick}>SUBSCRIBE NOW</button>
        </Link>
      )}
      <ul styleName="benefits">
        {data.benefits.map((benefit, index) => {
          return (
            <li key={index}>
              <i className="material-icons">check</i>
              {benefit}
            </li>
          );
        })}
        {data.plus && (
          <p>
            <span>PLUS</span>
          </p>
        )}
        {data.plus &&
          data.plus.map((benefit, index) => {
            return (
              <li key={index}>
                <i className="material-icons">check</i>
                {benefit}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

const GiftBlocks = ({ member }) => {
  const [data, setData] = React.useState({
    sender_name: member && (member.name || member.userName || ""),
    recipient_name: "",
    recipient_email: "",
    message: "",
    subscription_details: {
      sub_details: "Disruptor Annual",
      amount: 3000
    }
  });
  const [error, setError] = React.useState(null);
  const { recipient_name, recipient_email, message } = data;
  const planId = GIFTBLOCKS[0].planId;
  const dispatch = useDispatch();

  const { fetchSubscription } = useSelector(state => state);

  const handleChange = e => {
    const { name, value } = e.target;
    setData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const obj = {
      event: "subscription_addToCart",
      subscription_category: "gift_subscription",
      subscription_plan: `Disruptor - Yearly`,
      price: "3,000",
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    window.dataLayer.push(obj);

    try {
      if (!member) {
        window.location = `https://auth.newslaundry.com/user-login?callback-url=https://www.newslaundry.com&redirect-url=https://www.newslaundry.com/gift&intent=gift_subscription`;
        return false;
      }

      setData({ loading: true });
      window.localStorage.setItem("giftData", JSON.stringify(data));
      global.app.navigateToPage(
        dispatch,
        `/subscription/checkout?plan=${planId}&gift=true`
      );
    } catch (e) {
      console.log(e);
      setError(e);
    } finally {
      setData({ loading: false });
    }
  };

  return (
    <div styleName="gift-block-wrapper">
      <form styleName="gift-form" onSubmit={handleSubmit}>
        <h2>Enter Recipient's Information</h2>
        <div styleName="form-group">
          <label styleName="text">Recipient's Name*</label>
          <input
            styleName="input-text"
            required
            value={recipient_name}
            id="recipient_name"
            type="text"
            placeholder="Name"
            name="recipient_name"
            onChange={handleChange}
          ></input>
        </div>
        <div styleName="form-group">
          <label styleName="text">Recipient's Email*</label>
          <input
            styleName="input-text"
            required
            value={recipient_email}
            id="recipient's email*"
            type="email"
            placeholder="Email"
            name="recipient_email"
            onChange={handleChange}
          ></input>
        </div>
        <div styleName="form-group">
          <label styleName="text">Send a message</label>
          <textarea
            styleName="input-text"
            value={message}
            id="message"
            type="textarea"
            placeholder="Message"
            name="message"
            onChange={handleChange}
          ></textarea>
        </div>
        <button type="submit">Gift Subscription</button>
        <small>{error}</small>
      </form>
      {GIFTBLOCKS.map((block, index) => {
        return (
          <Block
            data={block}
            key={index}
            value={index}
            gift={true}
            member={member}
            intent="gift_subscription"
          />
        );
      })}
    </div>
  );
};
